import { ACTION_TYPES } from '@/actions';
import { judgeHasNextPage, getPagingList } from "@/core/util";

const INIT_STATE = {
  hasMore: true,
  records: []
};

export default function collectList(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    // 获取列表(分页)
    case ACTION_TYPES.GET_COLLECT_PAGING_LIST:
      result.hasMore = judgeHasNextPage(payload);
      result.records = getPagingList(result.records, payload);
      break;
    case ACTION_TYPES.GET_FOOTPRINT:
      result.hasMore = false;
      console.log("result", result);
      let footprintList = [];
      Object.keys(payload).forEach((key) => {
        footprintList = footprintList.concat(payload[key]);
      });
      result.records = footprintList;
      break;
    default:
      result = state;
  }
  return result;
}